export default __webpack_public_path__ + "static/media/metrics004.6bd05cc8.png";